import {Action} from './createAction';

export function combineReducer<T>(reducers, initialState) {
    return <K extends Action>(state: T = initialState, action: K): T => {
        const output = {};
        for (const key of Object.keys(reducers)) {
            output[key] = reducers[key](state[key], action);
        }

        return output as T;
    };
}
